import { render, staticRenderFns } from "./MainAttachmentRow.vue?vue&type=template&id=a8b8502c"
import script from "./MainAttachmentRow.vue?vue&type=script&lang=js"
export * from "./MainAttachmentRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports